import React from 'react'
import { BlockPicker, CirclePicker, CompactPicker, GithubPicker, SliderPicker, TwitterPicker } from 'react-color'
import { ColorPickerColors } from '../constants'
import PropTypes from "prop-types";
import { useState } from 'react';
// http://casesandberg.github.io/react-color/
const ColorPicker = ({ type, color: initial, onChangeColor, onChange, value, ...rest }) => {
  const [color, setColor] = useState(initial || value || "")
  const common = {
    colors: ColorPickerColors,
    color: color,
    onChangeComplete: color => {
      setColor(color)
      if (onChangeColor) {
        onChangeColor(color.hex)
      }
      if (onChange) {
        onChange(color.hex)
      }
    },
    ...rest
  }

  switch (type) {
    case "Github":
      return <GithubPicker {...common} />
    case "Twitter":
      return <TwitterPicker {...common} />
    case "Slider":
      return <SliderPicker {...common} />
    case "Compact":
      return <CompactPicker {...common} />
    case "Block":
      return <BlockPicker {...common} />
    case "Circle":
    default:
      return <CirclePicker {...common} />
  }

}
ColorPicker.propTypes = {
  color: PropTypes.string,
  value: PropTypes.string,
  onChangeColor: PropTypes.func,
  onChange: PropTypes.func,
  type: PropTypes.string
}
export default ColorPicker